var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPingPongTableFilled = function SvgHtlPingPongTableFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.747 13.939-2.354-1.36a.5.5 0 0 1-.184-.683l1.242-2.15a4.405 4.405 0 0 1-.648-1.88.5.5 0 0 1-.017-.1 5.238 5.238 0 0 1-.011-.37c-.003-.254.015-.51.053-.762a.527.527 0 0 1 .022-.09 5.64 5.64 0 0 1 .682-1.867c1.373-2.38 4.162-3.35 6.216-2.163C11.802 3.7 12.357 6.6 10.984 8.979a5.453 5.453 0 0 1-2.3 2.19.502.502 0 0 1-.136.046 4.422 4.422 0 0 1-1.862.368l-1.255 2.174a.5.5 0 0 1-.683.183l-.001-.001Zm-.312-3.9-1.11 1.922 1.49.859 1.109-1.922a.768.768 0 0 1 .573-.332c.474.044.951-.015 1.4-.173L3.841 8.05c.093.495.298.962.6 1.365a.5.5 0 0 1 .014.586.425.425 0 0 1-.021.039v-.002ZM10 11.997a2 2 0 1 1 0 .003v-.003Z"
  })));
};
export default SvgHtlPingPongTableFilled;